import { createElement } from "react";
import * as Lucide from "lucide-react";
/**
 * Resolve a lucide-react icon NAME (e.g. "CheckSquare") to a rendered element.
 * Nav data carries icons as strings (serializable, so the runtime apps-registry
 * can ship them as JSON) — the shell resolves the name to a component here.
 * Unknown / missing names render nothing.
 *
 * lucide icons are `forwardRef` components (typeof "object"), so we accept both
 * function and object component types and skip anything else exported from the
 * module (e.g. helpers like `createLucideIcon`).
 */
export function resolveIcon(name, size = 16) {
    if (!name)
        return null;
    const Comp = Lucide[name];
    if (!Comp || (typeof Comp !== "function" && typeof Comp !== "object"))
        return null;
    return createElement(Comp, { size });
}
//# sourceMappingURL=icons.js.map